import React from "react";
import RoadHead from "./roadHead";
import Timeline from "./timeline";
import RoadMile from "./roadMile";
import RoadComing from "./roadComing";

export default function Roadmap() {
  return (
    <div style={{color:'var(--text-clr)'}}>
      <RoadHead />
      {/* <Timeline /> */}
      <RoadMile />
      <RoadComing />
    </div>
  );
}
